<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="ACCESORIOS" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row class="mb-4">
              <b-col cols="12" class="pl-0">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Dispositivos de seguridad" :blank="form.security_devices.length != 0" show-reset @reset="form.security_devices = []" />
                  </template>
                  <b-checkbox-group v-model="form.security_devices" stacked size="lg" class="ml-3">
                    <b-checkbox value="Doble pareja de fotocelda">Doble pareja de fotocelda</b-checkbox>
                    <b-checkbox value="Una pareja de fotocelda">Una pareja de fotocelda</b-checkbox>
                    <b-checkbox value="Radares Flatscan">Radares Flatscan</b-checkbox>
                    <b-checkbox value="Radares de presencia y movimiento">Radares de presencia y movimiento</b-checkbox>
                    <b-checkbox value="Otro">Otro</b-checkbox>
                  </b-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pl-0">
                <ValidationProvider
                  v-if="form.security_devices.includes('Otro')"
                  name="Detalle"
                  :rules="{ required: form.security_devices_other }"
                  style="width: 100%"
                  v-slot="{ valid, errors }"
                >
                  <b-form-group class="w-100">
                    <template #label>
                      <Label label="Otros dispositivos de seguridad" :blank="form.security_devices_other" show-reset @reset="form.security_devices_other = ''" />
                    </template>
                    <b-textarea
                      v-model="form.security_devices_other"
                      rows="4"
                      trim
                      :state="errors[0] ? false : (valid ? true : false)"
                      placeholder="Especifique los otros dispositivos de seguridad"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>

            <b-row class="mb-4">
              <b-col cols="12" class="pl-0">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Dispositivos de activación externa" :blank="form.external_activation_devices.length != 0" show-reset @reset="form.external_activation_devices = []" />
                  </template>
                  <b-checkbox-group v-model="form.external_activation_devices" stacked size="lg" class="ml-3">
                    <b-checkbox value="Pulso de Control de Acceso">Pulso de Control de Acceso</b-checkbox>
                    <b-checkbox value="Radar de presencia y movimiento">Radar de presencia y movimiento</b-checkbox>
                    <b-checkbox value="Pulsador de microondas">Pulsador de microondas</b-checkbox>
                    <b-checkbox value="Botón">Botón</b-checkbox>
                    <b-checkbox value="Botón tipo Handicapped">Botón tipo Handicapped</b-checkbox>
                    <b-checkbox value="Switch de llave">Switch de llave</b-checkbox>
                    <b-checkbox value="Otro">Otro</b-checkbox>
                  </b-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pl-0">
                <ValidationProvider
                  v-if="form.external_activation_devices.includes('Otro')"
                  name="Detalle"
                  :rules="{ required: form.external_activation_devices_other }"
                  style="width: 100%"
                  v-slot="{ valid, errors }"
                >
                  <b-form-group class="w-100">
                    <template #label>
                      <Label label="Otros dispositivos de activación externa" :blank="form.external_activation_devices_other" show-reset @reset="form.external_activation_devices_other = ''" />
                    </template>
                    <b-textarea
                      v-model="form.external_activation_devices_other"
                      rows="4"
                      trim
                      :state="errors[0] ? false : (valid ? true : false)"
                      placeholder="Especifique los otros dispositivos de activación externa"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>

            <b-row class="mb-4">
              <b-col cols="12" class="pl-0">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Dispositivos de activación interna" :blank="form.internal_activation_devices.length != 0" show-reset @reset="form.internal_activation_devices = []" />
                  </template>
                  <b-checkbox-group v-model="form.internal_activation_devices" stacked size="lg" class="ml-3">
                    <b-checkbox value="Pulso de Control de Acceso">Pulso de Control de Acceso</b-checkbox>
                    <b-checkbox value="Radar de presencia y movimiento">Radar de presencia y movimiento</b-checkbox>
                    <b-checkbox value="Pulsador de microondas">Pulsador de microondas</b-checkbox>
                    <b-checkbox value="Botón">Botón</b-checkbox>
                    <b-checkbox value="Botón tipo Handicapped">Botón tipo Handicapped</b-checkbox>
                    <b-checkbox value="Switch de llave">Switch de llave</b-checkbox>
                    <b-checkbox value="Otro">Otro</b-checkbox>
                  </b-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pl-0">
                <ValidationProvider
                  v-if="form.internal_activation_devices.includes('Otro')"
                  name="Detalle"
                  :rules="{ required: form.internal_activation_devices_other }"
                  style="width: 100%"
                  v-slot="{ valid, errors }"
                >
                  <b-form-group class="w-100">
                    <template #label>
                      <Label label="Otros dispositivos de activación interna" :blank="form.internal_activation_devices_other" show-reset @reset="form.internal_activation_devices_other = ''" />
                    </template>
                    <b-textarea
                      v-model="form.internal_activation_devices_other"
                      rows="4"
                      trim
                      :state="errors[0] ? false : (valid ? true : false)"
                      placeholder="Especifique los otros dispositivos de activación interna"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>

            <StepNotes
              :value="form.components_notes"
              @update-form="updateStepNotes"
            />

            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
// import { componentOptions } from '../../../../sharedOptions/puertasAutomaticasModule'

import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import BlankIcon from '../BlankIcon'
import Label from '../Label'
import StepNotes from '../StepNotes'

export default {
  name: 'Components',
  components: { BlankIcon, ConfiguratorStepTitle, ValidationObserver, ValidationProvider, Label, StepNotes },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      form: {
        security_devices: [],
        external_activation_devices: [],
        internal_activation_devices: [],
        security_devices_other: '',
        external_activation_devices_other: '',
        internal_activation_devices_other: '',
        components_notes: ''
      },
      // selectOptions: componentOptions,
    }
  },
  mounted () {
    if (this.puerta) {
      this.form.security_devices = this.puerta.security_devices
      this.form.external_activation_devices = this.puerta.external_activation_devices
      this.form.internal_activation_devices = this.puerta.internal_activation_devices
      this.form.security_devices_other = this.puerta.security_devices_other
      this.form.external_activation_devices_other = this.puerta.external_activation_devices_other
      this.form.internal_activation_devices_other = this.puerta.internal_activation_devices_other
      this.form.components_notes = this.puerta.components_notes
    }
  },
  computed: {
    ...mapState({
      puerta: state => state.configurator.configurable
    }),
    ...mapGetters(['configuratorStepNumber'])
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.puerta[key])
    },
    updateStepNotes (notes) {
      this.form.components_notes = notes
    }
  }
}
</script>